// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};
M.View.ProductDetails.Mediator = _.clone(Backbone.Events);

/**
 * Image view for product details page
 */
M.View.ProductDetails.PreviewImage = Backbone.View.extend({
  events: {
    'click .altView.color': 'changeColorChoice',
    'click .altView.shape': 'changeShapeChoice',
    'click .altView': 'changeView',
    'click .greetingPicker a': 'changeAltGreetingChoice',
    'click .playButton': 'playGif',
    'click .pauseButton': 'pauseGif',
    'mouseenter .imageFeature': 'showPlaybackControls',
    'mouseleave .imageFeature': 'hidePlaybackControls'
  },

  getTrackedUrl: function() {
    return M.MintedAnalytics.getTrackedUrl(this.productImage.getImgUrl(), "ProductImage", "OldPdp");
  },

  initialize: function() {
    this.$img = this.$('img#main-image');
    this.$colorChoices = this.$('.altView.color');
    this.$shapeChoices = this.$('.altView.shape');
    this.$greetingChoices = this.$('.greetingPicker .altGreeting');
    this.initializeProductImage();
  },

  initializeProductImage: function() {
    var dieCutCode = this.$shapeChoices.filter('.selected').data('diecut-code');
    var colorCode = this.$colorChoices.filter('.selected').data('color-code');
    var colorChoiceId = this.$colorChoices.filter('.selected').data('color-choice-id');
    var greetingIndex = this.$greetingChoices.filter('.active').data('greeting-index');
    var greeting = this.$greetingChoices.filter('.active').data('greeting-name');
    var sku = this.$img.data('sku');

    var ext = 'jpg';

    if (this.options.isGifAnimationEnabled &&
        !(this.isFoilAndShape(dieCutCode) ||
          this.isDigitalLetterpressAndShape(dieCutCode) ||
          this.isLetterpressLuxuryCardAndShape(dieCutCode))) {
      ext = 'gif';
    }

    this.productImage = new M.Model.ProductImage({
      sku: sku,
      photoCode: M.PRODUCT_IMAGE.PHOTO_CODE.PD,
      viewCode: this.defaultViewCode(sku),
      colorCode: colorCode,
      dieCutCode: dieCutCode || null,
      colorChoiceId: colorChoiceId,
      greeting: greeting,
      greetingIndex: greetingIndex,
      ext: ext
    });

    this.$img.attr('src', this.getTrackedUrl());
  },

  defaultViewCode: function(sku){
    if (M.SKU.isNotebook(sku)) {
      return M.PRODUCT_IMAGE.VIEW_CODE.FRONT_SPIRAL_JOURNAL;
    } else {
      return M.PRODUCT_IMAGE.VIEW_CODE.FRONT_COMPOSITE;
    }
  },

  setImage: function(dieCut) {
    if (this.isFoilAndShape(dieCut)) {
      // for now, we can't support animations on foil + shapes products, other
      // than on the rectangular 'no die cut' shape
      this.$img.attr('src', this.removeAnimation(this.getTrackedUrl()));
    } else {
        this.$img.attr('src', this.getTrackedUrl());
    }
  },

  changeColorChoice: function(event) {
    this.$colorChoices.removeClass('selected');
    var $colorChoice = $(event.target);
    $colorChoice.addClass('selected');

    var colorCode = $colorChoice.data('color-code');
    var colorChoiceId = $colorChoice.data('color-choice-id');

    this.productImage.set({
      colorCode: colorCode,
      colorChoiceId: colorChoiceId
    });

    this.setImage(this.productImage.get('dieCutCode'));

    var foilColor = $colorChoice.data('foil-color');
    if (foilColor) {
      this.trigger('foilSelected', foilColor);
    }

    M.GA.trackEvent(
      M.GA.TRACK_EVENT_CATEGORY.PDP,
      M.GA.TRACK_EVENT_ACTION.CHANGE_COLOR,
      M.SKU.getProductKind(this.productImage.get('sku')),
      colorCode
    );
  },

  isFoilAndShape: function(dieCut) {
    return $('.foilPressBadge').length > 0 && dieCut;
  },

  isDigitalLetterpressAndShape: function(dieCut) {
    return $('.digitalLetterpressBadge').length > 0 && dieCut;
  },

  isLetterpressLuxuryCardAndShape: function(dieCut) {
    return $('.letterpressLuxuryCardBadge').length > 0 && dieCut;
  },

  removeAnimation: function(img) {
    return img.replace('.gif', '.jpg');
  },

  changeShapeChoice: function(event) {

    var $shapeChoice = $(event.target);

    this.$shapeChoices.removeClass('selected');
    $shapeChoice.addClass('selected');

    var dieCutCode = $shapeChoice.data('diecut-code');
    var dieCutName = $shapeChoice.data('diecut-name');
    M.View.ProductDetails.Mediator.trigger('shapeChanged', dieCutCode, dieCutName);

    this.productImage.set({
      dieCutCode: dieCutCode || null
    });


    this.setImage(dieCutCode);

    this.trigger("shapeSelected", dieCutCode);

    M.GA.trackEvent(
      M.GA.TRACK_EVENT_CATEGORY.PDP,
      M.GA.TRACK_EVENT_ACTION.SHAPE_OPTION_CLICK,
      M.SKU.getProductKind(this.productImage.get('sku')),
      dieCutCode
    );
  },

  changeAltGreetingChoice: function(e) {
    var $greetingLinks = $('.greetingPicker a').removeClass('active');

    var $clickedGreeting = $(e.currentTarget).addClass('active');

    var greeting = $clickedGreeting.data('greeting-name') ||
      $clickedGreeting.data('label');

    var greetingIndex = $clickedGreeting.data('greeting-index') ||
      $clickedGreeting.data('id');

    this.productImage.set({
      greeting: greeting,
      greetingIndex: greetingIndex
    });

    this.$img.attr('src', this.getTrackedUrl());

    M.GA.trackEvent(
      M.GA.TRACK_EVENT_CATEGORY.PDP,
      M.GA.TRACK_EVENT_ACTION.PRODUCT_GREETING_OPTION_CLICK,
      M.SKU.getProductKind(this.productImage.get('sku')),
      greeting);
  },

  changeView: function(event) {
    var $altView = $(event.target)
    var viewCode = $altView.data('view-code');
    if (viewCode) {
      // The actual view code is prefixed with the string 'view-code-'
      viewCode = viewCode.substring('view-code-'.length);

      this.productImage.set({
        viewCode: viewCode
      });

      this.$img.attr('src', this.getTrackedUrl());
    } else {
      var imgUrl = $altView.attr('photourl');
      this.$img.attr('src', imgUrl);
    }
  },

  updateViewCode: function(viewCode) {
    this.productImage.set({
      viewCode: viewCode
    });

    this.$img.attr('src', this.getTrackedUrl());
  },

  playGif: function() {
    if (!this.productImage) {
      return;
    }
    this.productImage.set({
      ext: 'gif'
    });

    this.$img.attr('src', this.productImage.getImgUrl());
    this.$('.playButton').removeClass().addClass('sprite pauseButton')
  },

  pauseGif: function() {
    if (!this.productImage) {
      return;
    }
    this.productImage.set({
      ext: 'jpg'
    });

    this.$img.attr('src', this.getTrackedUrl());
    this.$('.pauseButton').removeClass().addClass('sprite playButton');
  },

  showPlaybackControls: function() {
    if (!this.productImage) {
      return;
    }
    // There are only gifs for front composite images
    if (this.productImage.get('viewCode') ===
          M.PRODUCT_IMAGE.VIEW_CODE.FRONT_COMPOSITE) {
      if (this.isFoilAndShape(this.productImage.get('dieCutCode')) ||
          this.isDigitalLetterpressAndShape(this.productImage.get('dieCutCode')) ||
          this.isLetterpressLuxuryCardAndShape(this.productImage.get('dieCutCode'))) {
        return;
      }
      this.$('.pauseButton,.playButton').show();
    }
  },

  hidePlaybackControls: function() {
    if (!this.productImage) {
      return;
    }
    this.$('.pauseButton,.playButton').hide();
  }
});
